// Plaster the namespace with dollars for downstream scripts.

import $ from "jquery";
window.$ = window.jQuery = $;
globalThis.jQuery = $;
